import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import CustomModal from "../../../components/Modal";
import TableGrid from "../../../components/TableGrid";
import api from "../../../services/api";
import Loading from "../../../components/Loading";
import Content from "../../../components/Content";
import ContentHeader from "../../../components/ContentHeader";
import CardHeader from "../../../components/CardHeader";
import CardFooter from "../../../components/CardFooter";
import { toast } from "react-toastify";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { TabContext } from '@mui/lab';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Button from "../../../components/Button";
import SweetAlert from "sweetalert2";
import { FaKey } from "react-icons/fa";
import { FaWallet } from "react-icons/fa6";
import { HiDocumentReport } from "react-icons/hi";
import {
  decrypt,
} from "../../../util/rotinas"

import { formatTypeMoviment, formatInstituition, textLabels } from "../Relatorios/utils"
import _ from 'lodash'

import MUIDataTable from "mui-datatables";

import dayjs from 'dayjs'
import ptBr from 'dayjs/locale/pt-br'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import { CustomTolbarExportStatement } from "./CustomTolbarExportStatement";
import { useIsDesktop } from "../../../hooks/useIsDesktop";
dayjs.locale(ptBr)
dayjs.extend(LocalizedFormat)



const InstituiticaoNovo = (props) => {
  const history = useHistory();

   const isDesktop = useIsDesktop(800);

  const [loading, setLoading] = useState(false);
  const [, setInstituiticao] = useState(null);
  const [keysPix, setKeysPix] = useState([]);

  const [historyFee, setHistoryFee] = useState(null);

  const [form, setForm] = useState({})
  const [formFee, setFormFee] = useState({})
  const [formKeyPix, setFormKeyPix] = useState({})
  const [formCashout, setFormCashout] = useState({})

  const [filterDateIni, setFilterDateIni] = useState(dayjs().subtract(15, 'day').format('YYYY-MM-DD'))
  const [filterDateFim, setFilterDateFim] = useState(dayjs().format('YYYY-MM-DD'))

  const [statementMateraByClientFiltered, setStatementMateraByClientFiltered] = useState([])

  const [loadingBalance, setLoadingBalance] = useState(false)
  const [value, setValue] = React.useState('1');

  //MODALS
  const modalRef = useRef(null);
  const [isModalOpen, setModalStatus] = useState(false);

  const modalStatementRef = useRef(null)
  const [modalStatementOpen, setModalStatementOpen] = useState(false)
  const [loadingModalStatement, setLoadingModalStatement] = useState(false);

  const modalKeysPixRef = useRef(null)
  const [modalKeysPixOpen, setModalKeysPixOpen] = useState(false)
  const [loadingModalKeysPix, setLoadingModalKeysPix] = useState(false);

  const modalViewCashoutRef = useRef(null)
  const [modalViewCashoutOpen, setModalViewCashoutOpen] = useState(false)
  const [loadingModalViewCashout, setLoadingModalViewCashout] = useState(false);

  const modalCashoutRef = useRef(null)
  const [modalCashoutOpen, setModalCashoutOpen] = useState(false)
  const [loadingModalCashout, setLoadingModalCashout] = useState(false);

  const modalConfirmCashoutRef = useRef(null)
  const [modalConfirmCashoutOpen, setModalConfirmCashoutOpen] = useState(false)
  const [loadingConfirmModalCashout, setLoadingModalConfirmCashout] = useState(false);

  const handleCloseModalStatement = () => {
    setModalStatementOpen(false);
  }

  const handleCloseModalKeysPix = () => {
    setModalKeysPixOpen(false);
  }

  const handleCloseModalCashout = () => {
    setModalCashoutOpen(false);
  }

  const handleCloseModalViewCashout = () => {
    setModalViewCashoutOpen(false);
  }

  const handleCloseModalConfirmCashout = () => {
    setModalConfirmCashoutOpen(false);
  }

  function showModalStatement(e, row) {
    e.preventDefault()
    setModalStatementOpen(true)
    getStatementByMateraAccountId(form['mediator_account_id'])
  }

  function showModalKeysPix(e, row) {
    e.preventDefault()
    setModalKeysPixOpen(true)
    getKeysPix()
  }

  function showModalCashout(e, row) {
    e.preventDefault()
    setModalCashoutOpen(true)
  }

  function showModalViewCashout(e, row) {
    e.preventDefault()
    setModalViewCashoutOpen(true)
    // getMoviments(filterDateIni, filterDateFim)
  }


  const showModalConfirmCashout = async function (e, errors, values) {
    if (errors.length === 0) {
      setModalConfirmCashoutOpen(true)
    }
    else {
      SweetAlert.fire(`Valor invalido !`)
    }
  }

  function handleTransactionType(transactionType) {
    if (transactionType === "PAYMENTINSTANTPAYMENT") {
      return "RECEBIMENTO VIA QR-CODE"
    }
    else if (transactionType === "DEPOSITINSTANTPAYMENT") {
      return " RECEBIMENTO VIA CHAVE"
    }
    else if (transactionType === "WITHDRAWRETURNINSTANTPAYMENT") {
      return "DEVOLUÇÃO"
    }
    else if (transactionType === "WITHDRAWINSTANTPAYMENT") {
      return "RETIRADA CASHOUT"
    }
    else {
      return transactionType
    }
  }

  function calcularDataMaxima(dataFinal) {
    return dayjs(dataFinal).subtract(30, 'day').format('YYYY-MM-DD')
  }

  function calcularDataMinima(dataInicial) {
    const today = dayjs().toDate()
    const possibleDateMinima = dayjs(dataInicial).add(30, 'day').toDate()
    return possibleDateMinima > today ? dayjs(today).format('YYYY-MM-DD') : dayjs(possibleDateMinima).format('YYYY-MM-DD')
  }

  const handleDataInicialChange = (event) => {
    setFilterDateIni(event.target.value);
  };

  const handleDataFinalChange = (event) => {
    setFilterDateFim(event.target.value);
  };


  async function getBalanceMediatorAccountId() {
    setLoadingBalance(true)
    try {
      const response = await api.get(`/matera/get-balance-by-account-id?accountId=${form['mediator_account_id']}`)
      const saldo = response.data.data.available
      handleForm('saldo', saldo)
    } catch (error) {
      console.log(error)
      setLoadingBalance(false)
    } finally {
      setLoadingBalance(false)
    }
  }

  const handleChange = (event, newValue) => {
    setLoadingBalance(true)
    if (newValue === '2') {
      getBalanceMediatorAccountId()
    }
    setValue(newValue);
  };

  const handleChangeFilterDate = function (e, errors, values) {
    getStatementByMateraAccountId(form['mediator_account_id'])
  }

  function getStatementByMateraAccountId(account_id) {
    try {
      setLoadingModalStatement(true)
      api.get(`/matera/get-statement-by-account-id?accountId=${account_id}&ending=${filterDateFim}&start=${filterDateIni}`).then(res => {
        console.log(res.data.data)
        const dataT = res.data.data.map(item => {
          return {
            ...item,
            amount: String(item.type).toLowerCase() === "d" ? item.amount * -1 : item.amount
          }
        })
        setStatementMateraByClientFiltered(dataT)
        setLoadingModalStatement(false)
        return
        const data = res.data.data.statement.map(item => {
          if (item.type === "C") {
            return item
          } else {
            return {
              ...item,
              amount: item.amount * -1
            }
          }
        })

        let grouped_data = Object.values(_.groupBy(data, item => item.transactionId)).map(item => {
          if (item.length === 2) {
            if (item[0].type === "C") {
              return {
                ...item[0],
                credito: item[0].amount,
                taxa: item[1].amount,
                transactionType: handleTransactionType(item[0].transactionType),
                saldo: item[0].amount + item[1].amount
              }
            }
            else if (item[1].type === "C") {
              return {
                ...item[0],
                credito: item[1].amount,
                taxa: item[0].amount,
                transactionType: handleTransactionType(item[0].transactionType),
                saldo: item[0].amount + item[1].amount
              }
            }
            else {
              return {
                ...item[0],
                debito: item[0].amount,
                taxa: item[1].amount,
                transactionType: handleTransactionType(item[0].transactionType),
                saldo: item[0].amount + item[1].amount
              }
            }
          }
          else {
            return {
              ...item[0],
              credito: item[0].amount,
              taxa: 0,
              transactionType: handleTransactionType(item[0].transactionType),
              saldo: item[0].amount + 0
            }
          }
        })
        let grouped_dataSorted = grouped_data.sort((a, b) => new Date(b.entryDate) - new Date(a.entryDate))
        setStatementMateraByClientFiltered(grouped_dataSorted)
        setLoadingModalStatement(false)
      })

    } catch (err) {
      setLoadingModalStatement(false)
      console.log(err)
    }
  }

  async function getKeysPix(id) {
    try {
      setLoadingModalKeysPix(true)
      api.get(`/keyspix/findByInstituitionId?instituition_id=${props.match.params.id}`).then((res) => {
        const u = res.data.data;
        setKeysPix(u);
      });
    } catch (err) {
      console.log(err);
      setLoadingModalKeysPix(false)
    } finally {
      setLoadingModalKeysPix(false)
    }
  }

  const getInstituiticaoByPk = useCallback(() => {
    try {
      setLoading(true);
      api.get(`/instituition/findByPk?id=${props.match.params.id}`).then((res) => {
        const u = res.data.data;
        setInstituiticao(u);
        setForm(u)

      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [props.match.params.id]);

  const getHistoriesFeeByIdInstituition = useCallback(() => {
    try {
      api.get(`/instituitionfeehistory/listAllByIntituitionId?id=${props.match.params.id}`).then((res) => {
        const u = res.data.data;
        setHistoryFee(u);
      });
    } catch (err) {
      console.log(err);
    }
  }, [props.match.params.id]);

  useEffect(() => {
    if (props.match.params.id) {
      getInstituiticaoByPk()
      getHistoriesFeeByIdInstituition()
    }
  }, [getInstituiticaoByPk, getHistoriesFeeByIdInstituition, props.match.params.id]);

  const handleSubmit = function (e, errors, values) {
    if (errors.length === 0) {
      try {
        setLoading(true);
        if (!form.id) {
          api.post("/instituition", form).then(() => {
            toast.success(`Novo instituição cadastrada`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            history.push("/instituition");

          });
        } else {
          api.put(`/instituition`, form).then(() => {
            toast.success(`Registro atualizado com sucesso.`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            history.push("/instituition");
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    } else {
      errors.map((e) => {
        return toast.error(`Campo ${e} obrigatório`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        });
      });
    }
  };

  const handleSubmitTaxa = function (e, errors, values) {
    let temp = formFee
    temp.instituition_id = Number(props.match.params.id)
    const u = decrypt(localStorage.getItem("@ipm:user"), true);
    temp.user_id = u.id
    if (errors.length === 0) {
      try {
        api.post("/instituitionfeehistory", temp).then(() => {
          toast.success(`Novo Taxa Adicionada`, {
            position: "bottom-center",
            autoClose: true,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
            onClose: () => getHistoriesFeeByIdInstituition()
          });
        });
      } catch (err) {
        console.log(err);
      } finally {

        setModalStatus(false)
      }
    }
  };

  const handleSubmitKeyPix = function (e, errors, values) {
    let temp = {
      type: "EVP",
      key: formKeyPix.key,
      instituition_id: Number(props.match.params.id),
      customer_id: null,
      status: "ACTIVE",
    }

    if (errors.length === 0) {
      try {
        api.post("/keyspix", temp).then(() => {
          toast.success(`Nova chave adicionada`, {
            position: "bottom-center",
            autoClose: true,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
            onClose: () => getKeysPix()
          });
        });
      } catch (err) {
        console.log(err);
        setModalKeysPixOpen(false)
      } finally {
        setModalKeysPixOpen(false)
      }
    }
  };

  const handleSubmitCashout = async function (e, errors, values) {
    setLoadingModalConfirmCashout(true)

    if (errors.length === 0) {
      try {
        const u = decrypt(localStorage.getItem("@ipm:user"), true);
        let temp = {
          email: u.email,
          user_id: u.id,
          value: formCashout['value'],
          password: formCashout['password'],
          mediator_account_id: form['mediator_account_id'],
        }
        await api.post('/matera/cashout', temp).then(res => {
          toast.success('Retirada efetuada com sucesso !')
          setFormCashout({})
          // getMoviments(filterDateIni, filterDateFim)
          handleCloseModalCashout()
          handleCloseModalConfirmCashout()
          getBalanceMediatorAccountId()
        })

      } catch (error) {

        setLoadingModalConfirmCashout(false)
      } finally {

        setLoadingModalConfirmCashout(false)
      }
    }
  };

  function handleForm(key, value) {
    setForm({
      ...form,
      [key]: value
    })
  }

  function handleFormFee(key, value) {
    setFormFee({
      ...formFee,
      [key]: value
    })
  }

  function handleFormKeyPix(key, value) {
    setFormKeyPix({
      ...formKeyPix,
      [key]: value
    })
  }

  function handleFormCashout(key, value) {
    setFormCashout({
      ...formCashout,
      [key]: value
    })
  }

  function formatNumber(n) {
    return n.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })
  }

  function formatDate(n) {
    const novaData = new Date(n);
    return novaData.toLocaleString('pt-BR', { timezone: 'UTC' }).replace(',', ' -')
  }

  function deleteChavePix(e, row) {
    e.preventDefault()
    SweetAlert.fire({
      title: "Confirma exclusão da chave ? ",
      text: `${row.key} `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        api.delete('/keyspix/' + row.id).then(res => {
          toast.success(`Chave PIX deletada com sucesso.`, {
            position: "bottom-center",
            autoClose: true,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
            onClose: () => getKeysPix()
          });

        }).catch(err => {

          console.log(err)
        })
      }
    })
  }

  const columnsCashout = [
    {
      name: "created_at",
      label: "Data",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {dayjs(value).format('lll')}
            </div>
          )
        }
      }
    },

    {
      name: "instituition",
      label: "Instituição",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "auto" }}>
              {value}
            </div>
          )
        }
      }
    },
    {
      name: "type",
      label: "Tipo",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {formatTypeMoviment(value)}
            </div>
          )
        }
      }
    },
    {
      name: "user",
      label: "Usuario",
      options: {
        filter: true,
        filterType: "textField",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {value && value.name}
            </div>
          )
        }
      }
    },

    {
      name: "value",
      label: "Valor da transação",
      options: {
        filter: true,
        filterType: "textField",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {formatNumber(Number(value))}
            </div>
          )
        }
      }
    },
    {
      name: "fee",
      label: "Taxa",
      options: {
        filter: true,
        filterType: "textField",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {value}
            </div>
          )
        }
      }
    },

  ];

  const columnsKeyPix = useMemo(() => [
    {
      name: "Chaves",
      selector: "key",
      width: "400px",
      sortable: true,
    },
    {
      name: "Tipo",
      selector: "type",
      width: "100px",
      sortable: true,
    },
    {
      name: "Status",
      selector: "status",
      width: "100px",
      sortable: true,
    },
    {
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          <>
            <button
              onClick={e => deleteChavePix(e, row)}
              className="btn btn-danger btn-xs"
            >
              <i className="fa fa-fw fa-trash-o"></i>
            </button>
          </>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);

  const columnsFee = [
    {
      name: "fee_value",
      label: "TAXA",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", padding: '0 12px' }}>
              {formatNumber(Number(value))}
            </div>
          )
        }
      }
    },
    {
      name: "valid_from",
      label: "VÁLIDO DE",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {value && formatDate(value)}
            </div>
          )
        }
      }
    },
    {
      name: "valid_to",
      label: "VÁLIDO ATÉ",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {value && formatDate(value)}
            </div>
          )
        }
      }
    },
    {
      name: "user",
      label: "USUÁRIO",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", padding: '0 12px' }}>
              {value.name}
            </div>
          )
        }
      }
    },
  ];

  const options = {
    selectableRows: 'none',
    headerAlign: 'center',
    filter: false,
    search: false,
    viewColumns: false,
    download: false,
    print: false,
    filter: false,
    rowsPerPage: 5,
    rowsPerPageOptions: [5],
    tableBodyMaxHeight: '350px',
    tableHeadHeight: '200px',
    textLabels: {
      body: {
        noMatch: "Nenhum registro encontrado",
        toolTip: "Classificar",
      },
      pagination: {
        next: "Próxima página",
        previous: "Página anterior",
        rowsPerPage: "Por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Busca",
        downloadCsv: "Download CSV",
        print: "Imprimir",
        viewColumns: "Ver Colunas",
        filterTable: "Filtrar Tabelas",
      },
      filter: {
        all: "Todos",
        title: "FILTROS",
        reset: "LIMPAR",
      },
      viewColumns: {
        title: "Ver Colunas",
        titleAria: "Ver/Esconder Colunas da Tabela",
      },
      selectedRows: {
        text: "registros(s) selecionados",
        delete: "Excluir",
        deleteAria: "Excluir registros selecionados",
      },
    }
  };

  const columnsMoviments = [
    {
      name: "entryDate",
      label: "DATA",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {dayjs(value).format('lll')}
            </div>
          )
        }
      }
    },

    {
      name: "description",
      label: "Descrição",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {value}
            </div>
          )
        }
      }
    },
    // {
    //   name: "transactionType",
    //   label: "TIPO",
    //   options: {
    //     filter: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <div style={{ display: 'flex', justifyContent: "center" }}>
    //           {value}
    //         </div>
    //       )
    //     }
    //   }
    // },
    {
      name: "amount",
      label: "Lançamento",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {value > 0 ? <span style={{ color: 'green' }}>{formatNumber(Number(value))}</span> : <span style={{ color: 'red' }}>{formatNumber(Number(value))}</span>}
            </div>
          )
        }
      }
    },
    {
      name: "nsu",
      label: "NSU",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {value}
            </div>
          )
        }
      }
    },
    {
      name: "type",
      label: "Tipo",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
              {String(value).toLowerCase() === 'c' ? <span style={{ color: 'green' }}>Crédito</span> : <span style={{ color: 'red' }}>Débito</span>}
            </div>
          )
        }
      }
    },

  ]

  const columnsInfoMatera = useMemo(() => [
    {
      name: "Id da Conta Mediadora",
      selector: "mediator_account_id",
    },
    {
      name: "Saldo",
      selector: row => loadingBalance ? <Loading loading={loadingBalance} size={12} color={"black"} /> : row.saldo ? formatNumber(row.saldo) : formatNumber(0),
      width: '140px'
    },
    {
      width: '50px',
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-left">
          <button
            className="btn btn-primary btn-sm"
            onClick={e => showModalKeysPix(e, row)}
            style={{ padding: '8px', borderRadius: "8px" }}
          >
            <FaKey />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      width: '50px',
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-left">

          <button
            className="btn btn-primary btn-xs"
            onClick={e => showModalStatement(e, row)}
            style={{ padding: '8px', borderRadius: "8px" }}
          >
            <HiDocumentReport />
          </button>
        </div >
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      width: '120px',
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-left">

          <button
            className="btn btn-primary btn-xs"
            onClick={e => showModalViewCashout(e, row)}
            disabled={loadingBalance ? true : false}
            style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "space-between", padding: '8px', borderRadius: "8px" }}
          >
            <span>CASHOUT <FaWallet  /></span>
          </button>
        </div >
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);

  const optionsStatement = {
    selectableRows: 'none',
    filter: true,
    search: false,
    viewColumns: false,
    download: false,
    print: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [10],
    customToolbar: () => {
          return (
            <CustomTolbarExportStatement data={statementMateraByClientFiltered} />
          );
        },
    tableBodyMaxHeight: '400px',
    tableHeadHeight: '200px',
    textLabels: {
      body: {
        noMatch: "Nenhum registro encontrado",
        toolTip: "Classificar",
      },
      pagination: {
        next: "Próxima página",
        previous: "Página anterior",
        rowsPerPage: "Por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Busca",
        downloadCsv: "Download CSV",
        print: "Imprimir",
        viewColumns: "Ver Colunas",
        filterTable: "Filtrar Tabelas",
      },
      filter: {
        all: "Todos",
        title: "FILTROS",
        reset: "LIMPAR",
      },
      viewColumns: {
        title: "Ver Colunas",
        titleAria: "Ver/Esconder Colunas da Tabela",
      },
      selectedRows: {
        text: "registros(s) selecionados",
        delete: "Excluir",
        deleteAria: "Excluir registros selecionados",
      },
    }
  };

  return (
    <>
      <ContentHeader
        urlPrevious="/"
        previousTitle=" Pagina Inicial"
        smallTitle="Instituição"
      />
      <Content>
        <CardHeader
          title={"Instituições"}
          icon={"fa-building"}
          searchVisible={false}
        />
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="Informações Gerais" value="1" />
                {true && <Tab label="Financeiro" value="2" />}
              </TabList>
              <TabPanel value="1">

                <AvForm onSubmit={handleSubmit}>
                  <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
                    <div className="col-md-2">
                      <div className="form-group">
                        <AvField
                          type="text"
                          name="Código"
                          label="Código"
                          value={form['id'] ? form['id'] : ''}
                          readOnly
                        />
                      </div>
                    </div>
                    {!form.id ?
                      <div className="col-md-4">
                        <div className="form-group">
                          <AvField
                            type="text"
                            name="name"
                            label="Nome *"
                            placeholder="Nome"
                            value={form['name'] ? form['name'] : ''}
                            onInput={(e) => handleForm('name', e.target.value)}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Digite o nome para instituição.",
                              },
                            }}
                            autoFocus
                          />
                        </div>
                      </div>
                      :
                      <div className="col-md-4">
                        <div className="form-group">
                          <AvField
                            type="text"
                            name="name"
                            label="Nome *"
                            placeholder="Nome"
                            readOnly
                            value={form['name'] ? form['name'] : ''}
                            onInput={(e) => handleForm('name', e.target.value)}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Digite o nome para instituição.",
                              },
                            }}
                            autoFocus
                          />
                        </div>
                      </div>
                    }
                    <div className="col-md-6">
                      <div className="form-group">
                        <AvField
                          type="text"
                          name="mediator_account_id"
                          label="ID da conta Mediadora *"
                          placeholder="ID da conta Mediadora"
                          value={form['mediator_account_id'] ? form['mediator_account_id'] : ''}
                          onInput={(e) => handleForm('mediator_account_id', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <AvField
                          type="text"
                          name="url_api"
                          label="URL API *"
                          placeholder="Insira a URL da API do parceiro"
                          value={form['url_hml'] ? form['url_api'] : ''}
                          onInput={(e) => handleForm('url_api', e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <AvField
                          type="text"
                          name="secret_key"
                          label="Chave Secreta da API"
                          placeholder="Insira a chave Secreta da API"
                          value={form['secret_key'] ? form['secret_key'] : ''}
                          onInput={(e) => handleForm('secret_key', e.target.value)}
                        />
                      </div>
                    </div>
  
                    <div className="col-md-6">
                      <div className="form-group">
                        <AvField
                          type="text"
                          name="client_id_oauth2"
                          label="Id do Cliente OAuth2 *"
                          placeholder="Id do Cliente OAuth2"
                          value={form['client_id_oauth2'] ? form['client_id_oauth2'] : ''}
                          onInput={(e) => handleForm('client_id_oauth2', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <AvField
                          type="text"
                          name="client_secret_oauth2"
                          label="Segredo do Cliente OAuth2 *"
                          placeholder="Segredo do cliente"
                          value={form['client_secret_oauth2'] ? form['client_secret_oauth2'] : ''}
                          onInput={(e) => handleForm('client_secret_oauth2', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row" style={{ padding: "0px 10px 10px 10px" }}>
                      <div className="col-md-4">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={form['active'] || false}
                            onChange={() => handleForm('active', !form['active'])}
                          />
                          <label className="form-check-label">Ativo?</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <CardFooter loading={loading}>
                    <div style={{ display: 'flex' }}>
                      <Button type="submit" title="Salvar" loading={loading} />
                      <Button
                        type="button"
                        title="Cancelar"
                        isCanceled
                        loading={loading}
                        onClick={() => history.push("/instituition")}
                      />
                      <Button type="button" margin={'5px 5px 5px auto'} onClick={() => setModalStatus(true)} title="Gerenciar Taxas" loading={loading} />
                    </div>
                  </CardFooter>
                </AvForm>
              </TabPanel>
              <TabPanel value="2">
                <TableGrid
                  columns={columnsInfoMatera}
                  data={[form]}
                  pagination={false}
                  paginationPerPage={5}
                  loading={false}
                />
              </TabPanel>
            </Box>
          </TabContext>
        </Box >
      </Content >
      {/* MODAL GERENCIAMENTO DE TAXAS  */}
      <CustomModal
        id="modalValoresRepasse"
        close={() => {
          setModalStatus(false)
        }}
        open={isModalOpen}
        modalRef={modalRef}
      >
        <Content>
          <MUIDataTable
            title={"Histórico de Taxas"}
            data={historyFee}
            columns={columnsFee}
            options={options}
          />
          <AvForm onSubmit={handleSubmitTaxa}>
            <div className="row" style={{ padding: "10px 10px 0px 10px", display: "flex", justifyContent: "center", margin: "10px" }}>
              <div className="col-md-4" style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <AvField
                  type="number"
                  name="fee_value"
                  // label="Valor *"
                  placeholder="Insira uma nova taxa "
                  required
                  value={formFee['fee_value'] ? formFee['fee_value'] : null}
                  onInput={(e) => handleFormFee('fee_value', +e.target.value)}
                />
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} >
                  <Button type="submit" title="Enviar nova taxa" loading={loading} />
                </div>
              </div>
            </div>
          </AvForm>
        </Content>
      </CustomModal>
      {/* MODAL EXTRATO */}
      <CustomModal
        id="modalStatements"
        open={modalStatementOpen}
        close={handleCloseModalStatement}
        modalRef={modalStatementRef}
      >
        <Content>
          <div >
            <div style={{ padding: '20px' }}>
              <AvForm onSubmit={handleChangeFilterDate}>
                <div 
                    style={{
                          display: "flex",
                          flexDirection: isDesktop ? "row" : "column",
                          justifyContent: isDesktop ? "space-around" : "flex-start",
                          gap: isDesktop ?  12 : 2,
                          padding: 10,
                      }}>
                    <div style={{width : '100%'}} className="form-group">
                      <AvField
                        type="date"
                        name="filterDate"
                        label="Inicio"
                        value={filterDateIni}
                        min={filterDateFim ? calcularDataMaxima(filterDateFim) : ''}
                        max={dayjs().format('YYYY-MM-DD')}
                        required
                        onChange={handleDataInicialChange}
                      />
                    </div>
                    <div style={{width : '100%'}} className="form-group">
                      <AvField
                        type="date"
                        required
                        name="filterDate"
                        label="Fim"
                        value={filterDateFim}
                        max={filterDateIni ? calcularDataMinima(filterDateIni) : ''}
                        onChange={handleDataFinalChange}
                      />
                    </div>
                  <div style={{ display: "flex", alignItems: 'center'}}>
                    <button className="button-export" type="submit" disabled={false} > Buscar </button>
                  </div>
                </div>
              </AvForm>
            </div>

            {loadingModalStatement ? (
              <div style={{ minWidth: "100%" }}>
                <Loading loading={loadingModalStatement} margin={"20px"} size={72} color={"black"} />
              </div>
            ) : (
              <div>

                <MUIDataTable
                  title={"Extrato"}
                  data={statementMateraByClientFiltered}
                  columns={columnsMoviments}
                  options={optionsStatement}
                />
              </div>
            )}
          </div>
        </Content>
      </CustomModal>
      {/* MODAL CHAVES PIX */}
      <CustomModal
        id="modalKeysPix"
        open={modalKeysPixOpen}
        close={handleCloseModalKeysPix}
        modalRef={modalKeysPixRef}
      >
        <Content>
          <CardHeader
            title={"CADASTRAR CHAVE PIX"}
            icon={"fa-unlock-alt"}
            searchVisible={false}
          />
          <AvForm onSubmit={handleSubmitKeyPix}>
            <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
              <div className="col-md-10">
                <div className="form-group">
                  <AvField
                    type="text"
                    name="alias"
                    label="Chave PIX *"
                    placeholder="Insira a chave PIX"
                    value={form['key'] ? form['key'] : ''}
                    required
                    onInput={(e) => handleFormKeyPix('key', e.target.value)}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'end' }} className="col-md-2">
                <div className="form-group">
                  <Button
                    type="submit"
                    title="Cadastrar"
                    disabled={false}
                    loading={loading} />
                </div>
              </div>
            </div>
          </AvForm>
          <Content />
          <div style={{ width: "600px" }} />
          <TableGrid
            columns={columnsKeyPix}
            data={keysPix}
            paginationPerPage={5}
            loading={loadingModalKeysPix}
          />
        </Content>
      </CustomModal>

      {/* MODAL VISUALIZAÇÃO CASHOUT */}
      <CustomModal
        id="modalCashout"
        close={handleCloseModalViewCashout}
        open={modalViewCashoutOpen}
        modalRef={modalViewCashoutRef}
      >
        <Content>
          <div style={{ display: "flex", justifyContent: "center", padding: "8px 16px", marginTop: "10px" }}>
            <h3>Saldo disponível : {formatNumber(Number(form.saldo))}</h3>
          </div>
          <AvForm onSubmit={showModalCashout}>
            <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
              <div className="col-md-12" style={{ display: "flex", justifyContent: "center", padding: "16px" }}>
                <Button type="submit" title="Solicitar Saque" loading={loading} />
              </div>
            </div>
          </AvForm>

        </Content>
      </CustomModal>
      <CustomModal
        id="modalCashout"
        close={handleCloseModalCashout}
        open={modalCashoutOpen}
        modalRef={modalCashoutRef}
      >
        <Content>
          <AvForm onSubmit={showModalConfirmCashout}>
            <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
              <div className="col-md-12">
                <div className="form-group" >
                  <AvField
                    type="number"
                    name="value"
                    label=" *"
                    placeholder="Insira o valor a ser retirado"
                    required
                    value={formCashout['value'] ? formCashout['value'] : null}
                    onInput={(e) => handleFormCashout('value', +e.target.value)}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Digite o valor a ser sacado da conta",
                      },
                      min: {
                        value: 1,
                        errorMessage: `Valor mínimo: R$${1}`,
                      },
                      max: {
                        value: form['saldo'],
                        errorMessage: `Valor máximo: R$${form['saldo']}`,
                      },
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <CardFooter >
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button type="submit" title="Solicitar" loading={loading} />
                  </div>
                </CardFooter>
              </div>
            </div>
          </AvForm>
        </Content>
      </CustomModal>

      {/* MODAL DE CONFIRMAÇÃO DO CASHOUT */}
      <CustomModal
        id="modalConfirmCashout"
        close={handleCloseModalConfirmCashout}
        open={modalConfirmCashoutOpen}
        modalRef={modalConfirmCashoutRef}
      >
        <Content>
          <AvForm onSubmit={handleSubmitCashout}>
            <div className="row" style={{ padding: "10px 10px 0px 10px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <div className="col-md-12">
                <div className="form-group" style={{ display: "flex", justifyContent: "center" }}>
                  <span style={{ font: "16", fontWeight: "bold" }}>Insira sua senha para confirmar o saque</span >
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <AvField
                    type="password"
                    name="password"
                    placeholder="Senha "
                    required
                    value={formCashout['password'] ? formCashout['password'] : null}
                    onInput={(e) => handleFormCashout('password', e.target.value)}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Insira sua senha",
                      },

                    }}
                  />
                </div>
              </div>
              <div className="col-md-12" style={{ display: "flex", justifyContent: "center" }}>
                <CardFooter loading={false}>
                  <Button type="submit" title="Confirmar" disabled={formCashout.password === undefined || formCashout.password === "" ? true : false} loading={loadingConfirmModalCashout} />
                </CardFooter>
              </div>
            </div>
          </AvForm>

        </Content>
      </CustomModal>
    </>
  );
};

export default InstituiticaoNovo;
